import { Locale as DateFnsLocale } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';

import { Locale } from './locale.const';

export const dateFnsLocaleMap: Record<Locale, DateFnsLocale> = {
  [Locale.FR]: fr,
  [Locale.EN]: enUS,
};
